/* tslint:disable */

declare var Object: any;
export interface ViewHeadcountPosInterface {
  "total": number;
  "positionName"?: string;
}

export class ViewHeadcountPos implements ViewHeadcountPosInterface {
  "total": number;
  "positionName": string;
  constructor(data?: ViewHeadcountPosInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewHeadcountPos`.
   */
  public static getModelName() {
    return "ViewHeadcountPos";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewHeadcountPos for dynamic purposes.
  **/
  public static factory(data: ViewHeadcountPosInterface): ViewHeadcountPos{
    return new ViewHeadcountPos(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewHeadcountPos',
      plural: 'ViewHeadcountPos',
      path: 'ViewHeadcountPos',
      properties: {
        "total": {
          name: 'total',
          type: 'number'
        },
        "positionName": {
          name: 'positionName',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewHeadcountPos.ts